import { AadScopeEndpoints, PortalBackendEndpoints } from "Common/Constants";
import * as Logger from "Common/Logger";
import { configContext } from "ConfigContext";
export function normalizeArmEndpoint(uri) {
    if (uri && uri.slice(-1) !== "/") {
        return `${uri}/`;
    }
    return uri;
}
export var Environment;
(function (Environment) {
    Environment["Development"] = "Development";
    Environment["Mpac"] = "MPAC";
    Environment["Prod"] = "Prod";
    Environment["Fairfax"] = "Fairfax";
    Environment["Mooncake"] = "Mooncake";
})(Environment || (Environment = {}));
export const getEnvironment = () => {
    const environmentMap = {
        [PortalBackendEndpoints.Development]: Environment.Development,
        [PortalBackendEndpoints.Mpac]: Environment.Mpac,
        [PortalBackendEndpoints.Prod]: Environment.Prod,
        [PortalBackendEndpoints.Fairfax]: Environment.Fairfax,
        [PortalBackendEndpoints.Mooncake]: Environment.Mooncake,
    };
    return environmentMap[configContext.PORTAL_BACKEND_ENDPOINT];
};
export const getEnvironmentScopeEndpoint = () => {
    const environment = getEnvironment();
    const endpoint = AadScopeEndpoints[environment];
    if (!endpoint) {
        throw new Error("Cannot determine AAD scope endpoint");
    }
    const hrefEndpoint = new URL(endpoint).href.replace(/\/+$/, "/.default");
    Logger.logInfo(`Using AAD scope endpoint: ${hrefEndpoint}, Environment: ${environment}`, "EnvironmentUtility/getEnvironmentScopeEndpoint");
    return hrefEndpoint;
};
